export default "__VITE_ASSET__DLx1TBYh__"